<ng-template #customLoadingTemplate></ng-template>
<div class="card card-custom mb-5">
	<div class="card-header">
		<div class="card-title">Emitir Boleta de Honorarios</div>
	</div>
	<div class="card-content">
		<div class="card-body">
			<div class="row" *ngIf="currentEmisor">
				<div class="col-2">RUT:</div>
				<div class="col-2">
					{{ getRutOperando()}}
				</div>
			</div>
			<div class="row mt-3 mb-5" *ngIf="currentEmisor">
				<div class="col-2">RAZÓN SOCIAL:</div>
				<div class="col-2">
					{{ getNombreOperando() }}
				</div>
			</div>
			<div class="row" [formGroup]="emisorAsociadoFormGroup">
				<div class="col-10">
					<p>En la boleta de honorarios se mostrarán los giros de segunda categoría que usted posee, ¿Desea que ademas de estos giros, sea visible también la descripción de actividades que Ud. registra en el Servicio de Impuestos Internos y que se muestra a continuación?</p>
				</div>
				<div class="col-2 d-flex justify-content-end">
					<div class="radio-inline">
						<div class="custom-control custom-radio custom-control-inline"><input type="radio" class="ml-5" id="si" formControlName="mostrarDescripcion" name="mostrarDescripcion" class="custom-control-input" value="true" (change)="changeMuestraDescripcion($event)" /> <label class="custom-control-label" for="si">Si</label></div>
						<div class="custom-control custom-radio custom-control-inline"><input type="radio" class="ml-5" id="no" formControlName="mostrarDescripcion" name="mostrarDescripcion" class="custom-control-input" value="false" (change)="changeMuestraDescripcion($event)" /> <label class="custom-control-label" for="no">No</label></div>
					</div>
				</div>

				<!-- <div class="col-12 d-flex align-items-center">
					<p>En la boleta de honorarios se mostrarán los giros de segunda categoría que usted posee, ¿Desea que ademas de estos giros, sea visible también la descripción de actividades que Ud. registra en el Servicio de Impuestos Internos y que se muestra a continuación?</p>
					<div class="radio-inline">
						<div class="custom-control custom-radio custom-control-inline"><input type="radio" class="ml-5" id="si" formControlName="mostrarDescripcion" name="mostrarDescripcion" class="custom-control-input" value="true" (change)="changeMuestraDescripcion($event)" /> <label class="custom-control-label" for="si">Si</label></div>
						<div class="custom-control custom-radio custom-control-inline"><input type="radio" class="ml-5" id="no" formControlName="mostrarDescripcion" name="mostrarDescripcion" class="custom-control-input" value="false" (change)="changeMuestraDescripcion($event)" /> <label class="custom-control-label" for="no">No</label></div>
					</div>
				</div> -->
				<div class="col-12 mt-5 form-group">
					<div class="row d-flex align-items-center justify-content-between">
						<div class="col-10">
							<div class="row d-flex align-items-center" *ngIf="showDireccionInputs">
								<div class="col-3 label-control">Domicilio:</div>
								<div class="col-9 d-flex align-items-center" *ngIf="!loadingDirecciones">
									<ng-select [items]="direccionesSource" placeholder="Selecciona una dirección" formControlName="direccion" [clearable]="false" [multiple]="false" bindLabel="direccion"></ng-select>
									<div *ngIf="direccionesSource.length == 0 && !loadingDirecciones" class="text-danger">No hay direcciones disponibles para el emisor, se emitirá Boleta de honorarios con la primera dirección registrada en S.I.I</div>
								</div>
								<div class="col-9 d-flex align-items-center" *ngIf="loadingDirecciones">
									<div class="ml-2">Consultando direcciones en el SII <img src="./assets/deployAssets/icons/loader_16x16.gif" /></div>
								</div>
							</div>
							<div class="row d-flex align-items-center" *ngIf="!showDireccionInputs">
								<div class="col-3 label-control">Se emitirá a nombre de:</div>
								<div class="col-9">
									<div class="d-flex flex-row align-items-center">
										<ng-select [items]="personasAutorizadas" formControlName="personaAutorizada" [clearable]="false" [multiple]="false" bindLabel="nombre" (change)="seleccionarPersona($event)"></ng-select>
										<p *ngIf="personaSeleccionada" class="ml-2 mb-0">
											RUT: <strong>{{ personaSeleccionada.rutFormateado }}</strong>
										</p>
										<p *ngIf="personaSeleccionada" class="ml-3 mb-0">Email: {{ personaSeleccionada.correo }}</p>
										<div *ngIf="personasAutorizadas.length == 0 && !loadingPersonas" class="text-danger">No hay personas autorizadas para la emisión de terceros</div>
									</div>
								</div>
								<div class="col-9 d-flex align-items-center" *ngIf="loadingPersonas">
									<div class="ml-2">Obteniendo personas autorizadas <img src="./assets/deployAssets/icons/loader_16x16.gif" /></div>
								</div>
							</div>
						</div>
						<div class="col-2 d-flex justify-content-end">
							<div class="custom-control custom-switch">
								<input type="checkbox" class="custom-control-input" id="customSwitchTerceros" formControlName="deTerceros" (change)="changeTipoBhe($event)" />
								<label class="custom-control-label label-control" for="customSwitchTerceros" [ngbTooltip]="'Indica si la boleta de honorarios emitida es de terceros'">De Terceros</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
